var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.3369 32.1999V8.47363","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8.47363 20.3368L20.3368 8.47363L32.1999 20.3368","stroke":"white","strokeWidth":"3.38947","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUp.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;
